module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "container-fluid page-head-wrap"
  }, [_c('div', {
    staticClass: "container page-head"
  }, [_c('h3', {
    staticClass: "h4 text-center"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'mypage::event::cart',
        params: {}
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left back-icon",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('b', [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[8][1]"
    }
  })], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "container-fluid page-head-wrap"
  }, [_c('div', {
    staticClass: "container page-head"
  }, [_c('p', {
    staticClass: "text-center mb-0"
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[8][2]"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 offset-lg-2 col-lg-8"
  }, [_c('page-form', {
    attrs: {
      "orderer": _vm.orderer,
      "childInfos": _vm.childInfos,
      "cartEvents": _vm.cartEvents,
      "familyRelations": _vm.familyRelations,
      "storeData": _vm.storeData
    }
  })], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-341f2ecd!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/subPages/Order/Form.vue
// module id = 692
// module chunks = 0